import React from "react"
import PropTypes from "prop-types"
import { DateTime } from "luxon"
import { Link } from "gatsby"
import { Image, Box, Flex, Text } from "rebass"
import styled from "styled-components"

import { theme } from "./Layout"

const Title = styled.h1`
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  margin: 20px auto 0 auto;
  width: 90%;
  color: white;
  font-size: ${theme.fontSizes[6]}px;

  @media screen and (max-width: ${theme.breakpoints[1]}) {
    font-size: ${theme.fontSizes[3]}px;
  }
`

const BlogHero = ({ title, publishDate, featuredImage, slug, language }) => (
  <Box
    as="article"
    sx={{
      width: "100%",
      px: "0",
      my: "20px",
      textAlign: "center",
      position: "relative",
      overflow: "hidden",
      ">a": { textDecoration: "none" },
      "*": { transition: "all .5s ease" },
      "&:hover": {
        "h1, small": {
          transform: "translateY(-10px)",
        },
      },
    }}
  >
    <Link to={slug}>
      <Image src={featuredImage} alt={title} sx={{ width: "100%" }} />
      <Box
        as="span"
        sx={{
          display: "block",
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          background: "black",
          opacity: "0.3",
        }}
      />
      <Flex
        sx={{
          position: "absolute",
          px: 4,
          top: "50%",
          width: "100%",
          flexDirection: "column",
          transform: "translateY(-50%)",
        }}
      >
        <Title>{title}</Title>
        <Text
          as="small"
          sx={{
            textTransform: "uppercase",
            display: "inline-block",
            color: "white",
            fontSize: [1, 3, 4],
            my: 2,
          }}
        >
          {DateTime.fromISO(publishDate).toFormat("MMMM dd, yyyy", {
            locale: language === "es_MX" ? "es" : "en",
          })}
        </Text>
      </Flex>
    </Link>
  </Box>
)

BlogHero.propTypes = {
  title: PropTypes.string.isRequired,
  publishDate: PropTypes.string.isRequired,
  featuredImage: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  language: PropTypes.string,
}

BlogHero.defaultProps = {
  language: "en",
}

export default BlogHero
